import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Colors } from "Components/Layout/Themes/Colors";
import {
  TransactionDirection,
  TransactionStatus,
} from "Infrastructure/Api/Api";
import { Resources } from "Translations/Resources";
import DownloadingOutlinedIcon from "@mui/icons-material/DownloadingOutlined";
import type { ViewerTransactionDirection } from "Utils/TransactionUtils";
import type { ReactNode } from "react";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

export const STATUS_TO_ICON_MAP: Record<TransactionStatus, ReactNode> = {
  [TransactionStatus.Success]: (
    <CheckIcon sx={{ fontSize: 24, color: Colors.PrimaryMain }} />
  ),
  [TransactionStatus.Fail]: (
    <CloseIcon sx={{ fontSize: 24, color: Colors.RedDark }} />
  ),
  [TransactionStatus.Cancelled]: (
    <CloseIcon sx={{ fontSize: 24, color: Colors.RedDark }} />
  ),
  [TransactionStatus.InvestigationNeeded]: (
    <QuestionMarkIcon sx={{ fontSize: 24, color: Colors.WarningDark }} />
  ),
  [TransactionStatus.Created]: (
    <DownloadingOutlinedIcon sx={{ fontSize: 24, color: Colors.PrimaryMain }} />
  ),
  [TransactionStatus.Initiated]: (
    <DownloadingOutlinedIcon sx={{ fontSize: 24, color: Colors.PrimaryMain }} />
  ),
  [TransactionStatus.Processing]: (
    <DownloadingOutlinedIcon sx={{ fontSize: 24, color: Colors.PrimaryMain }} />
  ),
};

export const DIRECTION_TO_LABEL_KEY_MAP: Record<
  ViewerTransactionDirection,
  string
> = {
  [TransactionDirection.Incoming]:
    Resources.Components.Transactions.Direction.Incoming,
  [TransactionDirection.Outgoing]:
    Resources.Components.Transactions.Direction.Outgoing,
  [TransactionDirection.Unknown]: Resources.Transactions.Payment.Unknown,
};

export const isTransactionUnsuccessful = (status: TransactionStatus) =>
  [
    TransactionStatus.Fail,
    TransactionStatus.Cancelled,
    TransactionStatus.InvestigationNeeded,
  ].includes(status);
